export enum AuthBrowserStorageKeys {
  token = 'token',
  refreshToken = 'refreshToken',
}
